import { createContext, useContext } from 'react';
import { type UserAccountsLoadingState } from './types/user-accounts-loading-types';

export const UserAccountsLoadingContext = createContext<UserAccountsLoadingState>({
  isLoading: true,
  refetch: () => {},
});

export function useUserAccountsLoading(): UserAccountsLoadingState {
  return useContext(UserAccountsLoadingContext);
}
